import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-extraneous-dependencies
import { registerField } from 'core/forms';

import { TextArea } from 'uikit/inputs';
import { TextEditor } from 'uikit/textEditor';

const FormFieldTiptap = ({
  fieldId,
  model = {},
  schema = {},
  updateField = () => {},
  value = '',
}) =>
  !schema.hasPlainTextEditor || model.is_html ? (
    <TextEditor
      content={value ?? ''}
      id={fieldId}
      isDisabled={schema.isDisabled}
      onUpdateContent={updateField}
      options={schema.options}
      placeholder={schema.placeholder}
    />
  ) : (
    <TextArea
      id={fieldId}
      isDisabled={schema.isDisabled}
      onChange={updateField}
      placeholder={schema.placeholder}
      value={value ?? ''}
    />
  );

FormFieldTiptap.propTypes = {
  fieldId: PropTypes.string.isRequired,
  model: PropTypes.shape({ is_html: PropTypes.bool }),
  schema: PropTypes.shape({
    hasPlainTextEditor: PropTypes.bool,
    isDisabled: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.string),
    placeholder: PropTypes.string,
  }),
  updateField: PropTypes.func,
  value: PropTypes.string,
};

registerField('Tiptap', React.memo(FormFieldTiptap));

export default FormFieldTiptap;
